export function EmptyState() {
	return (
		<div className="rounded-md border border-dashed border-slate-800 bg-slate-950/40 p-4 text-center text-[11px] text-slate-500">
			Cart is empty. Add a withdraw from the Portfolio table or send a rebalance
			plan from the Rebalance section.
		</div>
	);
}
